<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="id ? '编辑行业' : '行业'"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
            <el-form-item label="名称" prop="name">
                <el-input v-model="item.name" placeholder="请输入行业名称"></el-input>
            </el-form-item>

            <el-form-item label="图标" prop="logo">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('logo', value)"
                        :show-file-list="false"
                        :action="app_url + '/admin/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.logo"></i>
                    <img :src="item.logo" v-else>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {quillEditor} from 'vue-quill-editor'

    export default {
        data() {
            return {
                item: {
                    logo: ''
                },
                isLoad: false,
                dialogVisible: false,
                id: this.$route.query.id,
                logo: [],
                rules: {
                    name: [
                        {required: true, message: '行业名称不存在', trigger: 'blur'},
                    ],
                    logo: [
                        {required: true, message: 'logo不存在'},
                    ],
                }
            }
        },
        created() {
            if (this.id) {
                this.loadData()
            }
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/industry/detail', {
                    id: this.id
                }).then(res => {
                    this.isLoad = !this.isLoad
                    // item是基础信息
                    this.item = res.data.detail
                    // 当图片存在的时候
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit() {
                // 存储图片且刷新 因为上传的和存储的图片不是同一个
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false
                let url = ''
                if (this.id) {
                    url = '/admin/industry/update'
                    this.item.id = this.id
                } else {
                    url = '/admin/industry/add'
                }
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            },
            beforeUpload(file) {
                var testmsg = file.type;
                const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
                if (!extension ) {
                    this.$message({
                        message: "上传文件只能是jpg或png格式!",
                        type: "warning",
                    });
                }
                return extension;
            },
            uploadSuccess(key, res, file) {
                this.item[key] = res.data.fileInfo.external_url
            },
            uploadRemove: function () {
                this.logo = []
            }
        },
        components: {
            quillEditor
        }
    }
</script>
<style scoped>
    .single-image .icon,.single-image img{
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
</style>
